import React, { useContext, useState } from 'react';
import { AppDataContext } from 'contexts/appData';
import { BannersContext } from 'contexts/banners';
import CONFIG from 'core/config'
import auto from 'resources/img/icons/auto.svg';
import home from 'resources/img/icons/home.svg';
import market from 'resources/img/icons/market.svg';
import parts from 'resources/img/icons/parts.svg';
import swoop from 'resources/img/icons/platforms/swooplogo.svg';
import tkt from 'resources/img/icons/tkt.svg';
import livo from 'resources/img/icons/livo.svg';
import supersim from 'resources/img/icons/supersim.svg';
// import saba from 'resources/img/icons/saba.svg';
import myjobs from 'resources/img/icons/myjobs.svg'
import superapp from 'resources/img/icons/supaerapp.svg'
import TnetLogo from 'components/icons/TnetFooter'

const TnetPlatforms = (props) => {
    const { isIos } = useContext(AppDataContext);
    const { resolution } = useContext(BannersContext);
    const {currentLang} = props

    let mobileLinks = isIos ? 'https://apps.apple.com/us/app/super-app-tnet/id6444474250' : 'https://play.google.com/store/apps/details?id=ge.tnet.superapp&pli=1'
    let detectDevice = resolution[0] <= CONFIG.TOSPLIT.RESPONSIVE_RESOLUTION ? mobileLinks : 'https://superapp.tnet.ge/'
    const [open, setOpen] = useState(false)
    const OpenLogos = () => {
        setOpen(!open)
    }

    const TnetLinks = {
      ka: [{ icon: auto, to: 'https://myauto.ge/ka' },
        { icon: parts, to: 'https://myparts.ge/ka', },
        { icon: home, to: 'https://myhome.ge/ka' },
        { icon: market, to: 'https://mymarket.ge/ka' },
        { icon: myjobs, to: 'https://myjobs.ge/ka' },
        { icon: superapp, to: detectDevice },
        { icon: tkt, to: 'https://tkt.ge/ka' },
        { icon: swoop, to: 'https://www.swoop.ge/ka' },
        { icon: livo, to: 'https://livo.ge/' },
        { icon: supersim, to: 'https://superesim.ge/ka', height: 'h-26px' }],
      en: [{ icon: auto, to: 'https://myauto.ge/en' },
        { icon: parts, to: 'https://myparts.ge/en', },
        { icon: home, to: 'https://myhome.ge/en' },
        { icon: market, to: 'https://mymarket.ge/en' },
        { icon: myjobs, to: 'https://myjobs.ge/en' },
        { icon: superapp, to: detectDevice },
        { icon: tkt, to: 'https://tkt.ge/en' },
        { icon: swoop, to: 'https://www.swoop.ge/en' },
        { icon: livo, to: 'https://livo.ge/' },
        { icon: supersim, to: 'https://superesim.ge/en', height: 'h-26px' },],
      ru: [{ icon: auto, to: 'https://myauto.ge/ru' },
        { icon: parts, to: 'https://myparts.ge/ru', },
        { icon: home, to: 'https://myhome.ge/ru' },
        { icon: market, to: 'https://mymarket.ge/ru' },
        { icon: myjobs, to: 'https://myjobs.ge/en' },
        { icon: superapp, to: detectDevice },
        { icon: tkt, to: 'https://tkt.ge/en' },
        { icon: swoop, to: 'https://www.swoop.ge/en' },
        { icon: livo, to: 'https://livo.ge/' },
        { icon: supersim, to: 'https://superesim.ge/ru', height: 'h-26px' },],
    }

    return (
        <div className="container px-0 px-lg-15px my-32px">
            <div className="footer-logo-box  border d-flex align-items-center position-relative z-index-997">
                <div className={`head d-flex justify-content-between align-items-center `} onClick={OpenLogos}>
                    <div className="tnet-footer-logo w-130px mr-24px  d-flex align-items-center  border-radius-64">
                        <TnetLogo />
                    </div>
                    <div className={`drop-arrow  ${open ? 'up' : ''}`}>
                        <i className={`svg-i arrow-down-black-i w-8px h-6px`}></i>
                    </div>
                </div>
                <div className={`platform-logos mx-n12px w-100 ${open ? 'active' : ''}`}>
                    {TnetLinks[currentLang].map((item, key) => (
                        <div className="px-12px item" key={key}>
                            <div className="py-20px">
                                <a href={item.to} target='_blank' rel="noopener noreferrer" className={`logos-hover cursor-pointer ${item.height || 'h-20px'} hover-bg-gray-450 d-flex align-items-center justify-content-center rounded transition-all`}>
                                    <img src={item.icon} alt="" className='max-height-26px w-100  h-100 object-fit-contain' />
                                </a>
                            </div>
                        </div>
                    ))}
                </div>
            </div>
        </div>
    )
}
export default TnetPlatforms
